export default "__VITE_ASSET__Cct5SsqH__"